<script lang="ts">
  import { browser } from '$app/environment';
  import Avatar from '$lib/components/reusable/images/Avatar.svelte';
  import type { HackathonProject } from '$shared/lib';

  export let project: HackathonProject;
</script>

<div class="mt-3 flex w-full flex-wrap items-center gap-2">
  {#each project.teamMembers as teamMember}
    <a
      href="/profiles/{teamMember.username}"
      class="bg-gray-dark-2 flex min-w-full items-center justify-between gap-x-2 rounded p-2 no-underline sm:min-w-[49%]"
    >
      <div
        class="font-architekt text-gray-dark-12 flex items-center gap-x-2 pl-1 text-xs leading-5"
      >
        <div class="h-6 w-6">
          {#if browser}
            {#key teamMember.username}
              <Avatar src={teamMember.avatarUrl ?? ''} seed={teamMember.username} class="h-6 w-6" />
            {/key}
          {/if}
        </div>
        <div class="flex flex-col gap-y-1">
          <h3 class="text-gray-dark-12 text-sm md:text-base">{teamMember.displayName}</h3>
          <p class="font-inter text-gray-dark-11 text-xs">
            @{teamMember.username}
          </p>
        </div>
      </div>
    </a>
  {/each}
</div>
